


































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

// Components
import CProdInvoiceConsolidationForm from "@/components/app/global/contractProducts/cProdInvoiceConsolidationForm.vue";

// Enums/Data
import { InvoiceConsolidationTypes } from "@/data/enums/invoice";
import { BrandConfigKeys } from "@/data/constants";

// Types
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  computed: {
    ...mapState({
      invoiceConsolidation(state: IState) {
        return state.brand.config[
          BrandConfigKeys.INVOICE_CONSOLIDATION_ENABLED
        ];
      }
    })
  },
  components: {
    "cprod-invoice-consolidation-form": CProdInvoiceConsolidationForm
  }
})
export default class CProdInvoiceConsolidationComp extends Mixins(
  CProdInjectorMixin
) {
  // Map State

  public invoiceConsolidation!: IClient["invoice_consolidation_enabled"];

  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    CProdInvoiceConsolidationForm: CProdInvoiceConsolidationForm;
  };

  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Computed

  public get isVisible() {
    if (!this.cProdData.isSubscription) return false;
    if (!this.cProdData.canUpdateContractProduct) return false;
    return this.showInvoiceConsolidationSection;
  }

  public get showInvoiceConsolidationSection() {
    const clientEnabled = this.cProdData.contract.client
      ?.invoice_consolidation_enabled;

    return (
      (clientEnabled === InvoiceConsolidationTypes.ENABLED ||
        (clientEnabled === InvoiceConsolidationTypes.INHERIT &&
          this.invoiceConsolidation)) &&
      this.cProdData.contractProduct.product?.invoice_consolidation_enabled
    );
  }

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.CProdInvoiceConsolidationForm.validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs.CProdInvoiceConsolidationForm.revertToInitialState();
  }
}
